<template>
  <div class="main">
    <div class="van-breadcrumb">
      <!-- 手动添加 Home 链接 -->
      <router-link
        to="/"
        class="van-breadcrumb__item van-breadcrumb__item--home"
      >
        首页
      </router-link>
      <span class="van-breadcrumb__separator">></span>
      <span
        v-for="(item, index) in $route.matched"
        :key="index"
        class="van-breadcrumb__item"
        :class="{
          'van-breadcrumb__item--active': index === $route.matched.length - 1,
        }"
      >
        <!-- 分隔符只在前一个路由项和当前路由项之间显示 -->
        <span class="van-breadcrumb__separator" v-if="index > 0">></span>
        <router-link
          v-if="index < $route.matched.length - 1"
          :to="item.path"
          class="van-breadcrumb__link"
        >
          {{ item.meta.display || item.name || item.path }}
        </router-link>
        <span v-else>{{ item.meta.display || item.name || item.path }}</span>
      </span>
      <!-- 最后一个分隔符在循环外部，但只在前一个路由项存在时显示 -->
      <span class="van-breadcrumb__separator" v-if="$route.matched.length > 1"
        >></span
      >
    </div>
    <div class="show-result">
      <div class="d-input">
        <input
          v-model="invoiceNumber"
          @input="validateInvoiceNumber"
          placeholder="请输入8位发票号"
          clearable
          type="number"
        />
        <van-button
          :disabled="!invoiceNumberError"
          class="btn-query"
          type="primary"
          block
          @click="onQuery"
          >查询</van-button
        >
      </div>
      <div class="d-content">
        <div class="content-left">
          <p>票号: {{ this.invoiceNumber }}</p>
        </div>
        <div class="content-right">
          <p>金额: {{ this.invoiceInfo.amount }}</p>
        </div>
      </div>
      <div class="d-reslut">
        <div class="result-left">
          <p :style="{ color: getColor(result) }">结果: {{ result }}</p>
        </div>

        <div class="result-right">
          <p>类型: {{ this.type }}</p>
        </div>
      </div>
      <div class="d-bottom" v-if="isAdd">
        <p>凭证号</p>
        <input
          v-model="invoiceInfo.voucher_number"
          placeholder="请输入凭证号"
          type="text"
        />
        <van-button class="btn-add" type="primary" block @click="onAdd" Z
          >报销</van-button
        >
      </div>
      <div class="d-del" v-if="isDel">
        <van-button class="btn-del" type="primary" block @click="onDel" Z
          >删除</van-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { getData, insertData, delData } from "../api/index";
import { Toast } from "vant";
export default {
  computed: {
    breadcrumbs() {
      // 假设每个路由记录的 meta.breadcrumb 都有一个 title 和 path 属性
      return this.$route.matched
        .filter((record) => record.meta.breadcrumb)
        .map((record) => ({
          title: record.meta.breadcrumb.title,
          path: record.path,
        }));
    },
  },
  data() {
    return {
      type: "", // 发票类型
      arr: [],
      isAdd: false,
      isDel: false,
      invoiceNumber: "", //发票号码
      result: "",
      user: "",
      invoiceNumberError: false,
      invoiceInfo: {
        unit_name: "",
        type: "",
        code: "",
        number: "",
        amount: 0,
        invoice_date: "",
        source: "",
        voucher_number: "",
        operate: "",
        memo: "",
      },
    };
  },
  methods: {
    validateInvoiceNumber() {
      // 使用正则表达式来检查是否只包含数字且至少为8位
      const regex = /^\d{8,}$/;
      this.invoiceNumberError = regex.test(this.invoiceNumber);
    },
    //查询票号事件
    async onQuery() {
      const params = {
        code: "00",
        number: this.invoiceNumber,
      };
      if (this.invoiceNumber.length < 8) {
        Toast({
          message: "请输入8位发票号",
          position: "middle",
          duration: 2000,
        });
        return;
      }
      //发送请求
      getData(params).then((res) => {
        if (res.code === 0) {
          //console.log(res.data);
          //console.log(this.invoiceInfo);
          this.type = res.data.typeId;
          if (res.data.number === null || res.data.number === "") {
            this.invoiceInfo.number = this.invoiceNumber;
            this.invoiceInfo.type = "";
            this.result = "未报销";
            this.isAdd = true;
            this.isDel = false;
          } else {
            this.invoiceInfo.amount = res.data.amount;
            this.invoiceInfo.type = res.data.typeId;
            this.invoiceInfo.number = res.data.number;
            this.result ="已报销（" + res.data.operate + res.data.operate_time + "）";
            if (res.data.voucher_number.length > 0)
              this.result = this.result + "凭证号：" + res.data.voucher_number;
            this.isAdd = false;

            //本人报销可撤销，非本人不行
            if (res.data.operate === this.user) {
              this.isDel = true;
            } else {
              this.isDel = false;
            }
          }
        } else {
          this.isAdd = false;
          this.isDel = false;
          Toast({ message: res.message, position: "middle", duration: 2000 });
        }
      });
    },

    //报销按钮事件
    async onAdd() {
      //console.log(this.invoiceInfo);
      //报销
      if (this.invoiceInfo.number) {
        //console.log(this.invoiceInfo);
        // 网络请求
        let data = await insertData(this.invoiceInfo);
        //consol.log(this.data);
        if (data.code === 0) {
          this.result = "报销成功";
          this.isAdd = false;
          this.isDel = true;
        }
      } else {
        Toast({
          message: "请输入正确的发票号",
          position: "middle",
          duration: 2000,
        });
      }
    },
    //删除按钮事件
    async onDel() {
      //撤销报销
      //报销
      if (this.invoiceInfo.number) {
        // 网络请求
        let data = await delData(this.invoiceInfo.number);
        if (data.code === 0) {
          this.result = "未报销";
          this.isAdd = true;
          this.isDel = false;
        }
      } else {
        Toast({ message: "无记录操作", position: "middle", duration: 2000 });
      }
    },

    getColor(result) {
      // 这里可以定义你的逻辑来根据value返回不同的颜色
      if (result) {
        if (result.includes("未")) {
          return "red";
        } else {
          return "lightgreen";
        }
      }
    },
  },
  watch: {
    invoiceNumber(invoiceNumber) {
      this.validateInvoiceNumber();
    },
  },
  created() {
    // 在组件创建时从 localStorage 读取 userInfo
    this.user = localStorage.getItem("userInfo");
    if (this.user) {
      //console.log(this.user)
      this.invoiceInfo.unit_name = JSON.parse(this.user).unit;
      this.invoiceInfo.operate = JSON.parse(this.user).user;
      this.user = JSON.parse(this.user).user;
    } else {
      // 本地  vuex
      this.$store.commit("LOGIN_OUT");
      Toast({ message: "登录已过期！", position: "middle", duration: 2000 });
      //登录成功跳转首页
      this.$router.push("/");
    }
    // 获取设备信息
    const regex = /\(([^()]+)\)/; // 正则表达式，匹配第一对括号及其内容
    const match = navigator.userAgent.match(regex);
    if (match && match[1]) this.invoiceInfo.memo = match[1]; // 返回括号里的内容
    else this.invoiceInfo.memo = ""; // 如果没有找到匹配项，返回 null
  },
};
</script>
<style scoped>
.main {
  /* 设置一个固定的最大宽度 */
  max-width: 512px; /* 根据你的需求调整这个值 */
  /* 使用margin: auto来水平居中 */
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #ddd;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100vh;
  padding: 16px;
  box-sizing: border-box;
  background-color: #f5f5f5; /* 背景色 */
  font-family: "Arial", sans-serif; /* 设置字体 */
}
/* 面包屑容器 */
.van-breadcrumb {
  display: flex;
  align-items: center;
  padding: 0;
  margin-bottom: 56px; /* 根据需要调整间距 */
  list-style: none; /* 移除默认的列表样式 */
  font-size: 14px; /* 字体大小 */
  color: #999; /* 默认文本颜色 */
  overflow: hidden; /* 防止面包屑溢出容器 */
}

/* 面包屑项 */
.van-breadcrumb__item {
  display: flex;
  align-items: center;
  color: inherit; /* 继承容器颜色 */
  text-decoration: none; /* 移除下划线 */
  transition: color 0.3s; /* 文本颜色过渡效果 */
}

/* 当前激活的面包屑项 */
.van-breadcrumb__item--active {
  color: #333; /* 活动状态的文本颜色 */
  font-weight: bold; /* 可选，用于强调 */
}

/* 面包屑链接 */
.van-breadcrumb__link {
  color: inherit; /* 继承父元素颜色 */
  text-decoration: none; /* 移除下划线 */
  transition: color 0.3s; /* 链接文本颜色过渡效果 */
}

/* 面包屑链接的悬停样式 */
.van-breadcrumb__link:hover {
  color: #409eff; /* 悬停时的文本颜色 */
  text-decoration: underline; /* 添加下划线 */
}

/* 面包屑项之间的分隔符 */
.van-breadcrumb__separator {
  margin: 0 8px; /* 分隔符的左右间距 */
  color: #ccc; /* 分隔符的颜色 */
}

/* 处理最后一个分隔符不显示的问题（如果有需要） */
.van-breadcrumb__item:last-child .van-breadcrumb__separator {
  display: none;
}

/* 面包屑链接的悬停样式（如果需要） */
.van-breadcrumb__link:hover {
  color: #409eff; /* 悬停时的文本颜色 */
  text-decoration: underline; /* 可选，添加下划线 */
}
.van-toast__text {
  padding: 0;
  margin: 0;
  text-align: center;
}
.show-result {
  padding-top: 16px;
  background-color: #fff;
  color: #333; /* 文本颜色为深灰色，保持不透明 */
  border-radius: 5px; /* 添加圆角 */
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
  width: 100%;
  height: 39%;
}
.d-input {
  padding: 0;
  margin: 1vh 0 1vh 0;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: space-between; /* 水平间距 */
  box-sizing: border-box; /* 确保内边距不会增加元素的总宽度 */
  height: 8vh;
}

.d-input input {
  margin: 0 0 0 2vh; /* 给p标签添加右边距，防止与输入框贴得太近 */
  margin-right: 10px; /* 与输入框之间的间距 */
  flex-grow: 1; /* 让输入框尽可能占据剩余空间 */
  margin-right: 10px; /* 给输入框添加右边距，防止与按钮贴得太近 */
  width: 30%;
  height: 80%;
  /* 这里可以添加van-button的样式，如果需要的话 */
  display: inline-block; /* 内联块级元素，便于布局 */
}
.d-input .btn-query {
  /* 这里可以添加van-button的样式，如果需要的话 */
  display: inline-block; /* 内联块级元素，便于布局 */
  margin-right: 2vh;
  border: none; /* 无边框 */
  border-radius: 5px; /* 添加圆角 */
  background-color: #007aff; /* 淡蓝色背景 */
  color: #fff; /* 白色文字 */
  font-weight: bold; /* 加粗文字 */
  cursor: pointer; /* 鼠标悬停时变为小手图标 */
  transition: background-color 0.3s ease; /* 过渡效果 */
  width: 28%;
  height: 100%;
}

.d-content {
  padding: 0;
  margin: 1vh 0 1vh 0;
  display: flex;
  justify-content: flex-start; /* 水平居中 */
}
.content-left {
  margin: 0;
  padding: 0;
  width: 60%;
}
.content-left p {
  margin-left: 2vh;
}
.content-right {
  width: 40%;
}
.d-reslut {
  padding: 0;
  margin: 1vh 0 1vh 0;
  display: flex;
  justify-content: flex-start; /* 水平居中 */
}
.result-left {
  margin: 0;
  padding: 0;
  width: 60%;
}
.result-right {
  width: 40%;
}
.result-left p {
  margin-left: 2vh;
}
.d-bottom {
  padding: 0;
  margin: 1vh 0 1vh 0;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: space-between; /* 水平间距 */
  box-sizing: border-box; /* 确保内边距不会增加元素的总宽度 */
  height: 8vh;
}
.d-bottom p {
  margin: 0 0 0 2vh; /* 给p标签添加右边距，防止与输入框贴得太近 */
  flex-shrink: 0; /* 防止标签缩小 */
  margin-right: 10px; /* 与输入框之间的间距 */
  font-size: 16px; /* 适当的字体大小 */
}

.d-bottom input[type="text"] {
  flex-grow: 1; /* 让输入框尽可能占据剩余空间 */
  margin-right: 10px; /* 给输入框添加右边距，防止与按钮贴得太近 */
  width: 30%;
  height: 80%;
  /* 这里可以添加van-button的样式，如果需要的话 */
  display: inline-block; /* 内联块级元素，便于布局 */
}
.d-bottom .btn-add {
  /* 这里可以添加van-button的样式，如果需要的话 */
  display: inline-block; /* 内联块级元素，便于布局 */
  margin-right: 2vh;
  border: none; /* 无边框 */
  border-radius: 5px; /* 添加圆角 */
  background-color: #007aff; /* 淡蓝色背景 */
  color: #fff; /* 白色文字 */
  font-weight: bold; /* 加粗文字 */
  cursor: pointer; /* 鼠标悬停时变为小手图标 */
  transition: background-color 0.3s ease; /* 过渡效果 */
  width: 28%;
  height: 100%;
}

.d-del {
  padding: 0;
  margin: 1vh 0 1vh 0;
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平间距分布 */
  height: 8vh;
}
.d-del .btn-del {
  display: inline-block; /* 内联块级元素，便于布局 */
  padding: 0 8vh 0 8vh; /* 添加内边距 */
  border: none; /* 无边框 */
  border-radius: 5px; /* 添加圆角 */
  background-color: #007aff; /* 淡蓝色背景 */
  color: #fff; /* 白色文字 */
  font-weight: bold; /* 加粗文字 */
  cursor: pointer; /* 鼠标悬停时变为小手图标 */
  transition: background-color 0.3s ease; /* 过渡效果 */
  width: 60%;
  height: 100%;
}
.scan-button {
  display: inline-block; /* 内联块级元素，便于布局 */
  padding: 0 8vh 0 8vh; /* 添加内边距 */
  border: none; /* 无边框 */
  border-radius: 5px; /* 添加圆角 */
  background-color: #007aff; /* 淡蓝色背景 */
  color: #fff; /* 白色文字 */
  font-weight: bold; /* 加粗文字 */
  cursor: pointer; /* 鼠标悬停时变为小手图标 */
  transition: background-color 0.3s ease; /* 过渡效果 */
  width: 60%;
  height: 100%;
}

/* 可选的：当按钮被按下时改变背景色 */
.scan-button:active {
  background-color: #3a8ee6;
}

.shoma {
  width: 100vw;
  height: 100vh;
}
.qr-scanner {
  background-image: linear-gradient(
      0deg,
      transparent 24%,
      rgba(32, 255, 77, 0.1) 25%,
      rgba(32, 255, 77, 0.1) 26%,
      transparent 27%,
      transparent 74%,
      rgba(32, 255, 77, 0.1) 75%,
      rgba(32, 255, 77, 0.1) 76%,
      transparent 77%,
      transparent
    ),
    linear-gradient(
      90deg,
      transparent 24%,
      rgba(32, 255, 77, 0.1) 25%,
      rgba(32, 255, 77, 0.1) 26%,
      transparent 27%,
      transparent 74%,
      rgba(32, 255, 77, 0.1) 75%,
      rgba(32, 255, 77, 0.1) 76%,
      transparent 77%,
      transparent
    );
  background-size: 3rem 3rem;
  background-position: -1rem -1rem;
  width: 100%;
  /* height: 100%; */
  height: 70vh;
  position: relative;
  background-color: #1110;
  /* background-color: #111; */
}
.qr-scanner .box {
  width: 213px;
  height: 213px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border: 0.1rem solid rgba(0, 255, 51, 0.2);
  /* background: url('http://resource.beige.world/imgs/gongconghao.png') no-repeat center center; */
}
.qr-scanner .line {
  height: calc(100% - 2px);
  width: 100%;
  background: linear-gradient(180deg, rgba(0, 255, 51, 0) 43%, #00ff33 211%);
  border-bottom: 3px solid #00ff33;
  transform: translateY(-100%);
  animation: radar-beam 2s infinite alternate;
  animation-timing-function: cubic-bezier(0.53, 0, 0.43, 0.99);
  animation-delay: 1.4s;
}
.qr-scanner .box:after,
.qr-scanner .box:before,
.qr-scanner .angle:after,
.qr-scanner .angle:before {
  content: "";
  display: block;
  position: absolute;
  width: 3vw;
  height: 3vw;
  border: 0.2rem solid transparent;
}
.qr-scanner .box:after,
.qr-scanner .box:before {
  top: 0;
  border-top-color: #00ff33;
}
.qr-scanner .angle:after,
.qr-scanner .angle:before {
  bottom: 0;
  border-bottom-color: #00ff33;
}
.qr-scanner .box:before,
.qr-scanner .angle:before {
  left: 0;
  border-left-color: #00ff33;
}
.qr-scanner .box:after,
.qr-scanner .angle:after {
  right: 0;
  border-right-color: #00ff33;
}
@keyframes radar-beam {
  0% {
    transform: translateY(-100%);
  }
  100% {
    transform: translateY(0);
  }
}
</style>
